
<header class="masthead" style="background-color:#1cd5db;">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-10 mx-auto" style="font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;">
                <div class="site-heading" style="padding: 28px 0;">

                </div>
            </div>
        </div>
    </div>
</header>
<br />
<br />
<div class="row">
	<div class="col-md-2 offset-md-5 mt-4">
		<div class="row  text-center" >
			<div class="col" style="border-right:1px solid">
				<a [routerLink]="['/login']" 
				routerLinkActive="active"><h3>Login</h3></a>
			</div>
			<div class="col">
				<a [routerLink]="['/register']" 
				routerLinkActive="active"><h3>Register</h3></a>
				
			</div>
		</div>
		<hr>
		<form #form="ngForm" (ngSubmit)="onSubmit(form)">
			<div class="form-group" style="margin-bottom: 5%;">
				<label for="loginUsername">Email</label>
				<input type="text" name="email" ngModel required #email="ngModel" class="form-control" id="loginUsername"
					   placeholder="Enter email">
			</div>
			
			<div class="form-group">
				<label for="loginPassword">Password</label>
				<input type="password" name="password" ngModel required #password="ngModel" class="form-control" id="loginPassword"
					   placeholder="Password">
			</div>
			<br>
			<div class="form-group">
				<button type="submit" 
				[disabled]="form.invalid" 
				class="btn btn-primary  form-control">Login <i class="fas fa-sign-in-alt"></i></button>

			</div>

		</form>
		<br>
		<div class="form-group">
			<a [routerLink]="['/forgotpassword']" 
			class="text-dark"	routerLinkActive="active">Forgot Password?</a>

		</div>
		<br>
		<div class="form-group">
			<a [routerLink]="['/resendemailconfirmation']" 
			class="text-dark"	routerLinkActive="active">Resend Email Confirmation</a>

		</div>

	
	</div>
</div>
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br /><br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />
<br />